"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Flex = _interopRequireDefault(require("./Flex"));
var _ReactUtils = _interopRequireDefault(require("../Utils/ReactUtils"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * An item in a list with a bullet point / icon
 */const ListItem = ({
  icon,
  children
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
  alignItems: "center",
  gap: 0.25,
  columnar: true,
  children: [icon && _ReactUtils.default.render(icon), children]
});
var _default = exports.default = ListItem;